export default __webpack_public_path__ + "static/media/airtel-card.8e5c80b0.png";